import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import themeReducer from './slices/themeSlice';
import companyReducer from './slices/companySlice';
import planConfigReducer from './slices/planConfigSlice';
import workspaceReducer from './slices/workspaceSlice';
import { localStorageMiddleware } from './middleware/localStorageMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    theme: themeReducer,
    company: companyReducer,
    planConfig: planConfigReducer,
    workspace: workspaceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(localStorageMiddleware),
});

// store.getState().auth    → auth state (user, token, permissions)
// store.getState().ui      → ui state (sidebar, modal, selectedRows)
// store.getState().theme   → theme state (dark/light mode)
// store.getState().company → company profile, plan, settings
